<div *ngIf="transfer.transferId != null">
  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Transferência</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-4">
          <label>Id</label>
          <input
            [(ngModel)]="transfer.transferId"
            data-cy="transferId"
            type="text"
            class="form-control"
            name="transferId"
            [readonly]="true"
          />
        </div>
        <div class="col-4">
          <label>Data Limite</label>
          <input
            [(ngModel)]="transfer.limitDate"
            data-cy="limitDate"
            type="date"
            class="form-control"
            name="limitDate"
            [readonly]="true"
          />
        </div>
        <div class="col-4">
          <label>Status</label>
          <input
            [(ngModel)]="transfer.status"
            data-cy="transferStatus"
            type="text"
            class="form-control"
            name="transferStatus"
            [readonly]="true"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-8">
          <label>Mensagem</label>
          <input
            [(ngModel)]="transfer.message"
            data-cy="transferMessage"
            type="text"
            class="form-control"
            name="transferMessage"
            [readonly]="true"
          />
        </div>
        <div class="col-4">
          <label>Data de Atualização</label>
          <input
            [(ngModel)]="transfer.lastStatusDate"
            data-cy="date"
            type="datetime-local"
            class="form-control"
            name="date"
            [readonly]="true"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-8">
          <label>Descrição</label>
          <input
            [(ngModel)]="transfer.description"
            data-cy="transferDescription"
            type="text"
            class="form-control"
            name="transferDescription"
            [readonly]="true"
          />
        </div>
        <div class="col-4">
          <label>Valor da Operação</label>
          <input
            [(ngModel)]="transfer.amount"
            data-cy="transferAmount"
            type="text"
            class="form-control"
            name="transferAmount"
            currencyMask
            [readonly]="true"
          />
        </div>
      </div>

      <h6 class="title-divider mt-4 mb-3">Dados do Remetente</h6>

      <div class="row mb-2">
        <div class="col-8">
          <label>Nome</label>
          <input
            [(ngModel)]="transfer.senderName"
            data-cy="transferSenderName"
            type="text"
            class="form-control"
            name="transferSenderName"
            [readonly]="true"
          />
        </div>
        <div class="col-4">
          <label>CPF/CNPJ</label>
          <input
            [(ngModel)]="transfer.senderDocument"
            data-cy="transferSenderDocument"
            type="text"
            class="form-control"
            name="transferSenderDocument"
            [textMask]="{
              mask: senderDocument,
              guide: false
            }"
            [readonly]="true"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4">
          <label>Banco</label>
          <input
            [(ngModel)]="transfer.senderBank"
            data-cy="transferSenderBank"
            type="text"
            class="form-control"
            name="transferSenderBank"
            [readonly]="true"
          />
        </div>
        <div class="col-4">
          <label>Agência</label>
          <input
            [(ngModel)]="transfer.senderBranch"
            data-cy="transferSenderBranch"
            type="text"
            class="form-control"
            name="transferSenderBranch"
            [readonly]="true"
          />
        </div>
        <div class="col-4">
          <label>Conta</label>
          <input
            [(ngModel)]="
              transfer.senderAccount + '-' + transfer.senderAccountDigit
            "
            data-cy="transferSenderName"
            type="text"
            class="form-control"
            name="transferSenderName"
            [readonly]="true"
          />
        </div>
      </div>

      <h6 class="title-divider mt-4 mb-3">Dados do Destinatário</h6>

      <div class="row mb-2">
        <div class="col-8">
          <label>Nome</label>
          <input
            [(ngModel)]="transfer.recipientName"
            data-cy="transferRecipientName"
            type="text"
            class="form-control"
            name="transferRecipientName"
            [readonly]="true"
          />
        </div>
        <div class="col-4">
          <label>CPF/CNPJ</label>
          <input
            [(ngModel)]="transfer.recipientDocument"
            data-cy="transferRecipientDocument"
            type="text"
            class="form-control"
            name="transferRecipientDocument"
            [textMask]="{
              mask: recipientDocument,
              guide: false
            }"
            [readonly]="true"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4">
          <label>Banco</label>
          <input
            [(ngModel)]="transfer.recipientBank"
            data-cy="transferRecipientBank"
            type="text"
            class="form-control"
            name="transferRecipientBank"
            [readonly]="true"
          />
        </div>
        <div class="col-4">
          <label>Agência</label>
          <input
            [(ngModel)]="transfer.recipientBranch"
            data-cy="transferRecipientBranch"
            type="text"
            class="form-control"
            name="transferRecipientBranch"
            [readonly]="true"
          />
        </div>
        <div class="col-4">
          <label>Conta</label>
          <input
            [(ngModel)]="
              transfer.recipientAccount + '-' + transfer.recipientAccountDigit
            "
            data-cy="transferRecipientName"
            type="text"
            class="form-control"
            name="transferRecipientName"
            [readonly]="true"
          />
        </div>
      </div>

      <div
        class="table-container"
        style="padding-top: 15px"
        *ngIf="transfer.logList.length > 0"
      >
        <table mat-table [dataSource]="transfer.logList" class="col-12">
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Data</th>
            <td mat-cell *matCellDef="let element">
              {{ element.date | date: "dd/MM/yyyy HH:mm" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">
              {{ element.status }}
            </td>
          </ng-container>

          <ng-container matColumnDef="errorMessage">
            <th mat-header-cell *matHeaderCellDef>Mensagem de Erro</th>
            <td mat-cell *matCellDef="let element">
              {{ element.errorMessage }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="ColumnsFile; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: ColumnsFile"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
